import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { RequestManagementService, } from '../services/request-management.service';
import { UserService } from '../services/user.service';
import 'rxjs/add/operator/map';
import { ServiceItemModel } from '../_models/_index';

@Injectable()
export class ServiceItemService {

    constructor(private requestManagement: RequestManagementService,
        private userService: UserService) { }

    public getServiceItems(): Promise<ServiceItemModel[]> {
        return this.requestManagement.callGetRequest('serviceItems/get', { 'userId': this.userService.getCurrentUser().id }).map((response: Response) => {
            return <ServiceItemModel[]>response.json();
        }).toPromise();
    }

    public addServiceItem(model: ServiceItemModel): Promise<ServiceItemModel> {
        model.creatorID = this.userService.getCurrentUser().id;
        return this.requestManagement.callPostRequest('serviceItems/add', model).map((response: Response) => {
            return <ServiceItemModel>response.json();
        }).toPromise();
    }

    public editServiceItem(model: ServiceItemModel): Promise<ServiceItemModel> {
        model.updatorID = this.userService.getCurrentUser().id;
        return this.requestManagement.callPostRequest('serviceItems/edit', model).map((response: Response) => {
            return <ServiceItemModel>response.json();
        }).toPromise();
    }

    public removeServiceItem(model: ServiceItemModel): Promise<ServiceItemModel> {
        model.updatorID = this.userService.getCurrentUser().id;
        return this.requestManagement.callPostRequest('serviceItems/remove', model).map((response: Response) => {
            return <ServiceItemModel>response.json();
        }).toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/service-item.service.ts